const columns = [
  {
    name: 'Name',
    selector: (row) => row.attributes.title_or_file_name,
    sortable: true,
    searchable: true,
  },

  {
    name: 'Date',
    selector: (row) => row.attributes.created_at,
    cell: (row) => row.attributes.created_at_formatted,
    sortable: true,
    searchable: true,
  },

];

export default columns;
